import {
  SET_OPERATION,
  SET_PAYBACK_INFO,
  SET_SPLIT_PURCHASE_INFO,
  SET_CONFIRM_MODAL_INFO,
  SET_MOVE_OPERATION_INFO,
  SET_CLONE_OPERATION_INFO,
  SET_CROPPER_INFO,
  SET_EVENT_SEARCH_VALUE,
  RESET_OPERATIONS_DATA,
} from './types';
import { resetOperations } from './operationsResettingFunc';

export const mutations = {
  [SET_OPERATION]: (state, operation) => {
    state.selectedOperation = operation;
  },
  [SET_PAYBACK_INFO]: (state, payback) => {
    Object.assign(state.paybackInfo, payback);
  },
  [SET_SPLIT_PURCHASE_INFO]: (state, purchase) => {
    state.purchaseInfo = purchase;
  },
  [SET_CONFIRM_MODAL_INFO]: (state, data) => {
    state.confirmModalInfo = { ...data };
  },
  [SET_MOVE_OPERATION_INFO]: (state, moveOperationInfo) => {
    state.moveOperationInfo = moveOperationInfo;
  },
  [SET_CLONE_OPERATION_INFO]: (state, cloneOperationInfo) => {
    state.cloneOperationInfo = cloneOperationInfo;
  },
  [SET_CROPPER_INFO]: (state, cropperInfo) => {
    state.cropperInfo = cropperInfo;
  },
  [SET_EVENT_SEARCH_VALUE]: (state, searchValue) => {
    state.eventSearchValue = searchValue;
  },
  [RESET_OPERATIONS_DATA]: (state) => {
    resetOperations(state);
  },
};

export const state = {
  selectedOperation: '',
  paybackInfo: {},
  purchaseInfo: {},
  confirmModalInfo: {},
  moveOperationInfo: {},
  cloneOperationInfo: null,
  cropperInfo: {},
  eventSearchValue: '',
};
